import { defaultId, defaultStyle, defaultTime } from "./shared.js";

// Column definitions.
const firstName = { ...defaultStyle, field: "first_name", headerName: "First name", flex: 0.15, minWidth: 100 };
const lastName = { ...defaultStyle, field: "last_name", headerName: "Last name", flex: 0.15, minWidth: 100 };
const bio = { ...defaultStyle, field: "bio", headerName: "Bio", flex: 0.2, minWidth: 160 };
const aliases = {
    ...defaultStyle,
    field: "aliases",
    headerName: "Aliases",
    flex: 0.15,
    minWidth: 120,
    filterable: false,
    sortable: false,
    valueGetter: (params) => (params.row.aliases || []).join(", ")
};
const exclusions = {
    ...defaultStyle,
    field: "exclusions",
    headerName: "Exclusions",
    flex: 0.2,
    minWidth: 140,
    filterable: false,
    sortable: false,
    valueGetter: (params) => (params.row.exclusions || []).join(", ")
};
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };

// Table columns.
export const columns = (props) => [defaultId, firstName, lastName, aliases, exclusions, bio, createdOn, updatedOn];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
